import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllRole = createAsyncThunk(
  "role/GetAllRole",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/role/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleRole = createAsyncThunk(
  "role/GetSingleRole",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/role/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateRole = createAsyncThunk(
  "role/CreateRole",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/role/`,
        {
          id: data.kode,
          nama: data.nama,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditRole = createAsyncThunk(
  "role/EditRole",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/role/${data.id}`,
        {
          nama: data.nama,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteRole = createAsyncThunk(
  "role/DeleteRole",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/role/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      if (responseDelete.data.success) {
        listData = await axios.get(`${api}master/role/all?${data.url}`, {
          headers: {
            Authorization: data.token,
          },
        });

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all role
    builder.addCase(GetAllRole.pending, loadingHandler);
    builder.addCase(GetAllRole.fulfilled, fulfilledHandler);
    builder.addCase(GetAllRole.rejected, rejectedHandler);
    // get Single role
    builder.addCase(GetSingleRole.pending, loadingHandler);
    builder.addCase(GetSingleRole.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleRole.rejected, rejectedHandler);
    // create role
    builder.addCase(CreateRole.pending, loadingHandler);
    builder.addCase(CreateRole.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateRole.rejected, rejectedHandler);
    // edit role
    builder.addCase(EditRole.pending, loadingHandler);
    builder.addCase(EditRole.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditRole.rejected, rejectedHandler);
    // delete role
    builder.addCase(DeleteRole.pending, loadingHandler);
    builder.addCase(DeleteRole.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isDelete: true });
    });
    builder.addCase(DeleteRole.rejected, rejectedHandler);
  },
});

export const { reset } = roleSlice.actions;
export default roleSlice.reducer;
